<template>
    <div class="card border-0">
        <div class="sectionclsbodymain tsk_body_right_back">
            <div class="serach_controls_main tsk_controls_main_cls">
                <div class="serach_controls_main_row1">
                    <div class="tsk_top_filter_left">
                        <div class="serach_controls me-2">
                            <SearchSvgIcon />
                            <input type="search" class="formmginput-control tsk_search" id="searchTxtId" placeholder="Search..." v-on:keyup="reloadSearch()">
                        </div>
                        <div class="serach_controlsx w-200 me-2">                    
                            <Select2 v-model="myValue" 
                            v-bind:id="'priorityStatusFilterId'"
                            :select=2 
                            :options="$store.state.stausOptions" 
                            :placeholder="'Select Status'"
                            :settings="{ minimumResultsForSearch: -1 }"
                            @change="myChangeEvent($event)" 
                            @select="mySelectEvent($event)"
                            />
                        </div>
                    </div>                   
                    <div class="tsk_top_filter_right">   
                        <AddEditPriority @reload-table-data="reloadSearch" ref="childComponentPriorityRef" />
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body p-0">
            <div class="table-responsive pageTblHeightCls">
                <table class="table table-bordered team_member_list_tsk" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Priority</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody class="tbodyCls shimmer-wrapper" v-if="tableLoader === 1">
                        <tr class="text-center " v-for="index in 15" :key="index">
                            <td v-for="index1 in 3" :key="index1">
                                <span class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></span>
                            </td>
                        </tr>
                    </tbody>
                    <tbody class="tbodyCls" v-else-if="tableLoader === 2">
                        <tr class="text-center">
                            <td colspan="3">
                                <ComponentNoData />
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr v-for="(item) in priorityList" :key="item._id">
                            <td>{{ item.priority }}</td>
                            <td v-if="item.status === true">
                                <div class="form-check form-switch mr-1">
                                    <input class="form-check-input" type="checkbox" role="switch" v-bind:id="buttonId(item._id)" v-bind:dataId="item._id" v-bind:dataVal="item.status" checked="" v-on:click="priorityStatusModal(item._id, item.status)">
                                    <label class="form-check-label" v-bind:for="buttonId(item._id)" ></label>
                                </div>
                            </td>
                            <td v-else>
                                <div class="form-check form-switch mr-1">
                                    <input class="form-check-input" type="checkbox" role="switch" v-bind:id="buttonId(item._id)" v-bind:dataId="item._id" v-bind:dataVal="item.status" v-on:click="priorityStatusModal(item._id, item.status)">
                                    <label class="form-check-label" v-bind:for="buttonId(item._id)" ></label>
                                </div>
                            </td>
                            <td>
                                <a href="javascript:;" class="cls_action" v-bind:id="item._id" v-on:click="modalEditOpen(item._id)" title="Edit">
                                    <EditSvgIcon />
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="d-flex px-3 databottom justify-content-between align-content-center" v-if="tableLoader == 3">
                <p v-if="page * pageLength > totalRecord">Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{
                    formatMoney(totalRecord) }} of {{ formatMoney(totalRecord) }} entries</p>
                <p v-else>Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{ formatMoney(page * pageLength) }} of {{
                    formatMoney(totalRecord) }} entries</p>
                <vs-pagination :total="totalLenght" :max="8" v-model="page" @click="reloadPagination(page)"></vs-pagination>
            </div>
        </div>
    </div>
    <input type="hidden" class="priorityValId" id="priorityValId"/>
    <input type="hidden" class="priorityStatusId" id="priorityStatusId"/>
</template>
<script>
import SearchSvgIcon from '@/components/Widgets/Icon/SearchSvgIcon.vue';
import ComponentNoData from '@/components/Widgets/Icon/ComponentNoData.vue';
import AddEditPriority from './AddEditPriority.vue';
import EditSvgIcon from '@/components/Widgets/Icon/EditSvgIcon.vue';
import Select2 from 'vue3-select2-component';
import $ from "jquery";
import {
    ref
} from 'vue';
import {
    formatMoney
} from '../../../helper'
import axios from 'axios'
    export default {
        name: 'PriorityPage',
        components: {
            Select2,
            SearchSvgIcon,
            ComponentNoData,
            EditSvgIcon,
            AddEditPriority
        },
        data() {
            return {
                currentx: 5,
                tableLoader: 1,
                page: 1,
                pageLength: this.$store.state.showEntries,
                searchKey: '',
                totalRecord: 0,
                totalLenght: 0,
                priorityList: [],
                myValue: 'true',
                taskMainListHeight: 0,
            }
        },
        async mounted() {
            this.$store.state.pageTitle = 'Priority'
            this.$store.state.isAdmin = 2
            
            if (this.$store.state.isActiveToken != '1') {
                // console.log(this.currentDate);
            } else {
                await this.loadPriorityData();
            }
            let temps = this
            $("body").on("click", '#searchTxtId', function () {
                if ($('#searchTxtId').val() != '') {
                    $('#searchTxtId').val('');
                    this.searchKey = '';
                    this.page = 1;
                    temps.reloadSearch()
                }
            });
            this.onResize();
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        computed: {
            iAT() {
                return this.$store.state.user.role_id
            },
        },
        watch: {
            async iAT(newValue) {
                if (this.$store.state.user.role_id != '') {
                    await this.loadPriorityData();
                }
                return newValue
            },
        },
        methods: {
            formatMoney,
            buttonId(id) {
                return "priority" + id;
            },
            async priorityStatusModal(_id, status) {
                document.getElementById('priorityStatusId').value = status
                document.getElementById('priorityValId').value = _id
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Confirm`,
                    text: 'Are you sure you want to update status?',
                    accept: this.priorityStatusChange,
                    cancel: this.priorityStatusCloseChange
                })
            },
            async priorityStatusCloseChange() {
                // const priorityStatusId = document.getElementById('priorityStatusId').value
                let priorityValId = document.getElementById('priorityValId').value
                let priorityValIdsds = true;
                if (priorityValId === 'false') {
                    priorityValIdsds = false;
                }
                document.getElementById("priority" + priorityValId).checked = priorityValIdsds;
            },
            async priorityStatusChange() {
                this.formLoader = 2
                const priorityStatusId = document.getElementById('priorityStatusId').value
                let priorityValId = document.getElementById('priorityValId').value
                let priorityValIdsds = false;
                if (priorityStatusId === 'false') {
                    priorityValIdsds = true;
                }

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                await axios.post(process.env.VUE_APP_API_URL + 'priority/status-update', {
                    status: priorityValIdsds,
                    priority_id: priorityValId,
                })
                    .then((resp) => {
                        if (resp.status == 200 && resp.data.status == 'success') {
                            this.$toast.success(resp.data.message);
                            this.loadPriorityData();
                        } else if (resp.status == 200 && resp.data.status == 'failure') {
                            this.errorMessage = resp.data.data;
                            this.errorRes = resp.data.message;
                        }
                        this.formLoader = 1
                    })
                    .catch(error => {
                        this.errorMessage = error.message;
                        console.error("There was an error!", error);
                        console.log("response", error.response.status);
                        console.log("message", error.response.data.message);
                        this.errorRes = error.response.data.message;
                        this.formLoader = 1
                    })
            },
            async reloadPagination(itemObjKey) {
                if (itemObjKey > 0 && itemObjKey !== -1 && itemObjKey <= this.totalLenght) {
                    this.page = itemObjKey;
                    this.loadPriorityData();
                }
            },
            myChangeEvent(val) {
                this.myValueRole = val
                this.loadPriorityData();
            },
            mySelectEvent({ id, text }) {
                console.log({ id, text })
                this.page = 1;
                this.loadPriorityData();
            },
            async reloadSearch() {
                const searchCls = document.getElementById('searchTxtId').value;
                this.searchKey = searchCls.trim();
                this.page = 1;
                this.loadPriorityData();
            },
            async loadPriorityData() {
                this.tableLoader = 1
                let token = localStorage.getItem('supportSystemAdmin');
                if (!token) {
                    this.$store.state.user.accessToken = ''
                }
                let priorityStatusFilterId = document.getElementById('priorityStatusFilterId').value
                let status = priorityStatusFilterId;
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                await axios.get(process.env.VUE_APP_API_URL + 'priority/list', {
                        params: {
                            page: this.page,
                            pageLength: this.pageLength,
                            searchKey: this.searchKey,
                            status: status,
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 200 && resp.data.status == 'success') {
                            this.priorityList = []
                            this.priorityList = resp.data.data.records
                            this.totalRecord = resp.data.data.totalRecord
                            this.totalLenght = this.totalRecord / this.pageLength
                            this.totalLenght = Math.ceil(this.totalLenght);
                            if (this.priorityList.length > 0) {
                                this.tableLoader = 3
                            } else {
                                this.tableLoader = 2
                            }
                            setTimeout(async () =>
                                this.onResize(),
                            100);
                        }else{
                            this.$store.state.user.accessToken = ''
                            this.$store.state.isActiveToken = ''
                            this.$store.state.user.userInfo = ''
                            this.$store.state.isAdmin = 2 
                            localStorage.removeItem("supportSystemAdmin");
                            this.$router.push({
                                path: '/login'
                            })
                        }
                    })
                    .catch(error => {
                        console.error("There was an error!", error);
                        console.log("response", error.response.status);
                        console.log("message", error.response.data.message);
                        // this.errorRes = error.response.data.message;
                    })
            },
            async modalEditOpen(priority_id) {
                $('.priorityValId').val(priority_id);
                this.callChildPriorityMethod();
            },
            onResize() {
                this.windowWidth = window.innerWidth
                this.windowHeight = window.innerHeight

                var headNavCls = $('.headNavCls').outerHeight() || 0;
                var tsk_tabs = $('.tsk_tabs').outerHeight() || 0;
                var tsk_controls_main_cls = $('.tsk_controls_main_cls').outerHeight() || 0;
                var thead = $('thead').outerHeight() || 0;
                var databottom = $('.databottom').outerHeight() || 0;

                var cntSubvar = headNavCls + tsk_tabs + tsk_controls_main_cls + thead + databottom
                var tabHei = headNavCls + tsk_tabs + tsk_controls_main_cls + databottom
                cntSubvar = this.windowHeight - cntSubvar - 30
                tabHei = this.windowHeight - tabHei - 30
                this.taskMainListHeight = tabHei;
                $('tbody').height(cntSubvar);
                $('.pageTblHeightCls').height(tabHei);
                this.checkHeightScroll();
            },
            checkHeightScroll() {
                $('.table').removeClass('ScrollAddedCls');
                if (this.hasScrollBar() == true) {
                    $('.table').addClass('ScrollAddedCls');
                }
            },
            hasScrollBar() {
                if ($(".tbodyCls")[0]) {
                    return $('.tbodyCls').get(0).scrollHeight > $('.tbodyCls').height() + 10;
                } else {
                    return false;
                }
            },
        },
        setup() {
            const childComponentPriorityRef = ref(null);
            const callChildPriorityMethod = () => {
                if (childComponentPriorityRef.value) {
                    childComponentPriorityRef.value.modalEditOpen();
                }
            };
            return {
                childComponentPriorityRef,
                callChildPriorityMethod,
            };
        },
    }
</script>